import { createFileRoute } from '@tanstack/react-router';

import { ContractPage } from '../../../../features/documents/ui/contract-page.tsx';
import { requirePermissionRoute } from '../../../../lib/permissions.ts';

export const Route = createFileRoute('/_app/sales/deals/$id_/contract')({
  beforeLoad: requirePermissionRoute('sales.use'),
  component: ContractRoute,
});

/** Договор сделки на всю страницу: `/sales/deals/<id>/contract`. */
function ContractRoute() {
  const { id } = Route.useParams();
  return <ContractPage dealId={id} />;
}
